import PropTypes from "prop-types";
import MedicalIcon from "/public/images/icons/medicalIcon.svg?react";
import MedicineIcon from "/public/images/icons/medicineIcon.svg?react";
import AllergyIcon from "/public/images/icons/allergyIcon.svg?react";
import EditPencilIcon from "/public/images/icons/editPencil.svg?react";
import BinIcon from "/public/images/icons/trashRed.svg?react";

export default function MedicalCard({
  removeFunc,
  editFunc,
  checkedFunc,
  medication,
  type,
}) {
  const dateAdded = medication?.dateAdded ? new Date(medication.dateAdded) : medication?.DateAdded ? new Date(medication.DateAdded) : null;
  const formattedDate = dateAdded ? dateAdded.toLocaleDateString() : 'Date not available';

  return (
    <div
      className={`border-[1px] border-[#E3E3E3] bg-white rounded-[4px] p-6 flex flex-col gap-5`}
    >
      <div className="space-y-1 flex justify-between items-center">
        {/* Top Block */}
        <div>
          {type === "medication" ? 
            <MedicineIcon />
          : type === "allergy" ?
            <AllergyIcon />
          : <MedicalIcon />}
        </div>
        <div className="flex flex-col">
          <div className="leading-[34px] text-[16px] capitalize font-semibold antialiased">
            {medication?.name || medication?.medicationName || medication?.ConditionName || medication?.MedicationName}
          </div>
          <div className="text-sportsDarkGrey leading-6">
            Date Added • {formattedDate}
          </div>
        </div>
        <div onClick={editFunc} data-testid="edit-button">
          <EditPencilIcon />
        </div>
      </div>

      {type !== "allergy" && (
          <div className="form-control w-full flex items-center">
            <label className="cursor-pointer label w-[110px]">
              <span className="label-text font-semibold text-[#101820]">Ongoing</span>
              <input
                type="checkbox"
                checked={medication?.ongoing || medication?.OnGoing}
                onChange={checkedFunc}
                className="checkbox checkbox-medical"
              />
            </label>
          </div>
              )}

      <div className="border-dashed w-full border border-[#E3E3E3]" />
      <div className="space-y-2 text-center w-full">
        {/* Bottom Block */}
        <div
          onClick={removeFunc}
          data-testid="remove-button"
          className="flex w-full justify-center gap-2 text-sportsRed underline font-semibold"
        >
          <BinIcon />
          Remove
        </div>
      </div>
    </div>
  );
}

// MedicalCard.propTypes = {
//   removeFunc: PropTypes.func.isRequired,
//   editFunc: PropTypes.func.isRequired,
//   checkedFunc: PropTypes.func.isRequired,
//   medication: PropTypes.shape({
//     dateAdded: PropTypes.oneOfType([
//       PropTypes.string,
//       PropTypes.instanceOf(Date)
//     ]).isRequired,
//     ongoing: PropTypes.bool.isRequired,
//     name: PropTypes.string.isRequired,
//   }).isRequired,
// };
